import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import format from 'date-fns/format';
import Pagination from "react-js-pagination";
import pagiarray from 'paginate-array';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { subMonths } from 'date-fns';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import NumberFormat from 'react-number-format';
import SelectPriod from "../util/SelectPriod";
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

var activePage = 1;
var totalCount = 0; //총회원수
const pageSize = 10;
var refundData = '';
var clear = false;
var name = '';
var phone = '';
var priodClear = false;

const now = new Date();
const month = subMonths(now, 1);
const monthdate = new Date(month.getFullYear(), month.getMonth(), month.getDate(), 0, 0, 0);

var filterMode = {
    name : true,
    phone : true
}

let storage = {
    nameKeyword : '',
    phoneKeyword : ''
}

let loaded = false;

export default function Refund() {
    let sdate = monthdate;
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [startDate, setStartDate] = useState(sdate);
    const [endDate, setEndDate] = useState(new Date());
    const [purchase, setPurchase] = useState([]);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    
    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handlePageChange(changepage) {
        activePage = changepage;
        const page = activePage;
        const pageCurrent = pagiarray(refundData,page,pageSize);
        
        totalCount = refundData.length;

        setPurchase(pageCurrent.data);
    }
    
    function handleStartChange(date) {
        setStartDate(date);
        priodClear = true;
    }

    function handleEndChange(date) {
        setEndDate(date);
        priodClear = true;
    }
    
    function getPurchase(){
        const formatStartDate = format(startDate, 'yyyyMMdd');
        const formatEndDate = format(endDate, 'yyyyMMdd')
        const sdate = formatStartDate + "000000";
        const edate = formatEndDate + "235959";

        if(clear === true){
            name = ''
            phone = '';
        }else{
            name = storage.nameKeyword;
            phone = storage.phoneKeyword;
        }
        var temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        let mode = 'server';
        let node_api = 'https://api.smartg.kr:3000'
        if(mode === 'local'){
            node_api = "http://192.168.76.23:3000"
        }
        
        axios({
            url : node_api+ "/refund/get_refund",
            method : "post",
            data : {
                cid : temp_cid,
                nameKeyword : name,
                phoneKeyword : phone,
                startDate : sdate,
                endDate : edate
            }
        }).then(function (res){
            refundData = res.data.rows;
            const page = activePage;
            const pageCurrent = pagiarray(refundData,page,pageSize);
            
            totalCount = refundData.length;

            setPurchase(pageCurrent.data);
        }).catch(function(error){
            console.log(error);
        })
    }

    function handleClear(){
        storage.nameKeyword = '';
        storage.phoneKeyword = '';
        setStartDate(monthdate);
        setEndDate(new Date());
        clear = true;
        activePage = 1;
        getPurchase();
    }

    function handleSelectedPriod(sdate, edate){
        setStartDate(new Date(sdate));
        setEndDate(edate);
        getPurchase();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        storage.phoneKeyword = filterData.phoneKeyword;
        activePage = 1;
        clear = false;
        getPurchase();
    }

    function handleAdd(){
        let answer = window.confirm('환불신청은 구매 상세페이지에서 신청할 수 있습니다. \n구매 관리페이지로 이동하시겠습니까?')
        if(answer){
            window.location.href = '/purchase';
        }
    }

    function handleClick(seq){
        window.location.href = '/refundInfo/'+seq;
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getPurchase();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getPurchase();
            activePage = 1;
        }
    },[selectedCenter]);

    useEffect(()=>{
        if(loaded){
            getPurchase();
            activePage = 1;
        }
    },[startDate, endDate]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner purchase">
            <h3 style={{display : "inline-block"}}>환불 관리</h3>
            <div className="content-component">
                <div className="content-header">
                    <Button className="add-button" onClick={() => handleAdd()}><MonetizationOnOutlinedIcon /> &nbsp; 환불 추가 </Button>
                    <SelectCenter 
                        onSelectedCenter={handleSelectedCenter}
                    />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div className="search-left-container">
                        <span className="mr-1 white-title">날짜&nbsp;</span>
                        <DatePicker
                            selected = {startDate}
                            onChange={handleStartChange}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            locale="ko"
                        />
                        <span>&nbsp;~&nbsp;</span>
                        <DatePicker
                            selected = {endDate}
                            onChange={handleEndChange}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            style={{width:'100px'}}
                            locale="ko"
                        />
                        <SelectPriod onSelectedPriod={handleSelectedPriod} onClear = {priodClear}/>
                        </div>
                        <Filter 
                            handleFilter = {handleFilter}
                            handleClear = {handleClear}
                            mode = {filterMode}
                        />
                    </div>
                    <div className="table-body">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th style={{width:'100px'}}>고객명</th>
                                <th style={{width:'150px'}}>연락처</th>
                                <th style={{width:'180px'}}>가맹점</th>
                                <th style={{width:'370px'}}>종목</th>
                                <th style={{width:'120px'}}>구매금액</th>
                                <th style={{width:'100px'}}>상태</th>
                                <th style={{width:'180px'}}>등록일</th>
                            </tr>
                        </thead>
                        <tbody>
                        {(totalCount === 0) &&
                                <tr>
                                    <td colSpan='20'>
                                        데이터가 없습니다.
                                    </td>
                                </tr>
                        }
                        {purchase.map(( purchase, index ) => {
                            const { seq, name, phone, itemName1, itemName2, price, center, location, state, regdate } = purchase;
                            return(
                                <tr key={index} onClick={() => handleClick(seq)}>
                                    <td>
                                        {name}
                                    </td>
                                    <td>{phone}</td>
                                    <td>{center + " " +location}</td>
                                    <td className="td-itemname">{itemName1 + " " + itemName2}</td>
                                    <td><NumberFormat value={price} displayType={'text'} thousandSeparator={true} suffix={'원'} /></td>
                                    <td>{state}</td>
                                    <td>{moment(regdate).format('YYYY-MM-DD HH:mm')}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table>
                    </div>
                    <Pagination
                        activePage={activePage}
                        itemsCountPerPage={pageSize}
                        pageRangeDisplayed={5}
                        totalItemsCount={totalCount}
                        itemClass="page-item"
                        linkClass="page-link"
                        onChange={handlePageChange}
					/>
                </div>
            </div>
            </div>
            </div>
        </main>
    )
}